// extracted by mini-css-extract-plugin
module.exports = {"locationContainer":"LocationProfile_locationContainer__2h64x","locationText":"LocationProfile_locationText__XdOiF","locationName":"LocationProfile_locationName__1wA4A"};